<bp-validation-error
	*ngIf="!suppress"
	[formControlName]="formControlName$ | async"
	[errors]="errors$ | async"
	[animate]="animate"
>
</bp-validation-error>
